import React from "react";
import { useHistory } from "react-router-dom";
import { Box, Slide, Typography, Stack, Button } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PageHeader from "../../components/PageHeader";
import ArrowRow from "../../components/ArrowRow";
import { getUserDetail } from "../../constants/function";
export default function Libary() {
  const userDetail = getUserDetail();
  const history = useHistory();
  return (
    <Slide direction="left" in={true} mountOnEnter unmountOnExit>
      <Box>
        <PageHeader title="Libary" />
        <Box className="__main_pading">
          <Stack direction="column" spacing={2} sx={{ marginTop: "1rem" }}>
            <ArrowRow
              title="Upload Music"
              path="/app/UploadMusic"
              color="primary"
            />
            <ArrowRow title="My Music" path={`/app/MyMusic`} />
            <ArrowRow title="My Playlists" path="/app/Playlists" />
            <ArrowRow title="My Albums" path="/app/Albums" />
            <ArrowRow title="My NFTs" path="/app/Nft" />
            <ArrowRow title="My Subscription" path="/app/Subscription" />
          </Stack>

          <Stack
            spacing={3}
            direction={"column"}
            sx={{
              marginTop: "3rem",
              border: "2px dashed #4D4D4D",
              padding: "20px 10px",
              textAlign: "center",
              borderRadius: "24px",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "58px",
                height: "58px",
                margin: "auto",
                border: "2px dashed #4D4D4D",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                position: "absolute",
                top: "-33px",
                left: "0",
                right: "0",
                background: "#1E1E1E",
              }}
            >
              <LockOpenIcon sx={{ color: "#fff" }} />
            </Box>
            <Box>
              <Button
                variant="contained"
                color="accent"
                endIcon={<ArrowForwardIosIcon />}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
                onClick={() => history.push("/app/unlockedAssets")}
              >
                Unlocked Assets
              </Button>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Slide>
  );
}
